import React from 'react';
import {
    ModalOverlay,
    ModalContent,
    ModalHeader,
    ModalTitle,
    ModalBody,
    ButtonGroup,
    CancelButton,
    DeleteButton,
    CloseButton
} from '../../styles/WorkspaceSection.styles';

const DeleteWorkspaceModal = ({ onClose, onConfirm }) => (
    <ModalOverlay onClick={onClose}>
        <ModalContent onClick={e => e.stopPropagation()}>
            <ModalHeader>
                <ModalTitle>Delete Workspace</ModalTitle>
                <CloseButton onClick={onClose}>&times;</CloseButton>
            </ModalHeader>
            <ModalBody>
                <p>Are you sure you want to delete this workspace?</p>
                <p>All projects will be moved to Other Projects.</p>
                <ButtonGroup>
                    <CancelButton onClick={onClose}>
                        Cancel
                    </CancelButton>
                    <DeleteButton onClick={onConfirm}>
                        Delete Workspace
                    </DeleteButton>
                </ButtonGroup>
            </ModalBody>
        </ModalContent>
    </ModalOverlay>
);

export default DeleteWorkspaceModal;